import request from "@/utils/request";
import process from "shelljs";

//获取中联数据
export function getZlData(data) {
    return request({
        url: '/apiconversion/api/data/post',
        method: 'post',
        data
    })
}

//获取推荐医生列表
export function getRecommendDoctorList() {
    return request({
        url: '/internet_api/basic/doctor/recomm',
        method: 'post'
    })
}

//获取推荐医生列表
export function getDoctorDetails(data) {
    return request({
        url: '/internet_api/basic/doctor/detail',
        method: 'post',
        data
    })
}

//获取科室列表
export function getDeptList(data) {
    return request({
        url: '/internet_api/basic/dept/list',
        method: 'post',
        data
    })
}

//获取科室详情
export function getDeptDetails(data) {
    return request({
        url: '/internet_api/basic/dept/detail',
        method: 'post',
        data
    })
}

//获取科室下医生列表
export function getDeptDoctorList(data) {
    return request({
        url: '/internet_api/basic/dept/doctor',
        method: 'post',
        data
    })
}

//根据科室id获取部门下医务人员信息
export function getZoomDeptDoctorList(data) {
    return request({
        url: '/internet_api/zoom/basic/deptDoctor',
        method: 'post',
        data
    })
}

//整合S1001与S1003，按科室过滤并仅返回医生
export function getZoomDeptDoctorMergedList(data) {
    return request({
        url: '/internet_api/zoom/basic/deptDoctorMerged',
        method: 'post',
        data
    })
}

//获取科室下医生号源列表
export function getDeptNumberSourceList(data) {
    return request({
        url: '/internet_api/register_queue/doctor_list',
        method: 'post',
        data
    })
}

//获取医生号源详情
export function getDoctorNumberSourceList(data) {
    return request({
        url: '/internet_api/register_queue/doctor_detail',
        method: 'post',
        data
    })
}

/**
 * 获取token
 * @returns {*}
 */
export function getNewVersionToken() {
    let data = {user_name: process.env.VUE_APP_LOGIN_USER, pass_word: process.env.VUE_APP_LOGIN_PSW}
    return request({
        url: '/internet_api/login',
        method: 'post',
        data
    })
}

//预约挂号-锁号
export function regLockNs(data) {
    return request({
        url: '/internet_api/register/lock',
        method: 'post',
        data
    })
}

//获取挂号记录
export function getRegistrationRecord(data) {
    return request({
        url: '/internet_api/visit/list',
        method: 'post',
        data
    })
}

//获取挂号详情
export function getRegistrationDetail(data) {
    return request({
        url: '/internet_api/visit/detail',
        method: 'post',
        data
    })
}

//退号
export function returnNumber(data) {
    return request({
        url: '/internet_api/payment_refund/register',
        method: 'post',
        data
    })
}

//获取门诊待缴费列表
export function getOpToBePaidList(data) {
    return request({
        url: '/internet_api/expense_mz/wait/list',
        method: 'post',
        data
    })
}

//获取门诊已缴费列表
export function getOpPaidList(data) {
    return request({
        url: '/internet_api/expense_mz/already/list',
        method: 'post',
        data
    })
}

//获取已缴费处方详情
export function getPrescriptionPaidDetails(data) {
    return request({
        url: '/internet_api/expense_mz/already/detail',
        method: 'post',
        data
    })
}

//获取待缴费处方详情
export function getPrescriptionUnPaidDetails(data) {
    return request({
        url: '/internet_api/expense_mz/wait/detail',
        method: 'post',
        data
    })
}

//获取住院列表
export function getHospitalizedList(data) {
    return request({
        url: '/internet_api/expense_zy/recode/list',
        method: 'post',
        data
    })
}

//获取住院详情
export function getHospitalizedDetails(data) {
    return request({
        url: '/internet_api/expense_zy/recode/balance',
        method: 'post',
        data
    })
}

//获取住院每日清单
export function getHospitalizedDetailsList(data) {
    return request({
        url: '/internet_api/expense_zy/day_detail',
        method: 'post',
        data
    })
}

//获取住院预缴金余额
export function getAdvancePayment(data) {
    return request({
        url: '/internet_api/expense_zy/recode/balance',
        method: 'post',
        data
    })
}

//获取检验报告列表
export function getInspectReportList(data) {
    return request({
        url: '/internet_api/report/inspect/list',
        method: 'post',
        data
    })
}

//获取检验报告详情
export function getInspectReportDetails(data) {
    return request({
        url: '/internet_api/report/inspect/detail',
        method: 'post',
        data
    })
}

//获取检查报告列表
export function getCheckReportList(data) {
    return request({
        url: '/internet_api/report/check/list',
        method: 'post',
        data
    })
}

//获取检查报告详情
export function getCheckReportDetails(data) {
    return request({
        url: '/internet_api/report/check/detail',
        method: 'post',
        data
    })
}

//住院预缴金充值
export function getAdvancePaymentPay(data) {
    return request({
        url: '/internet_api/expense_zy/pay',
        method: 'post',
        data
    })
}

//取消锁号
export function unlockNumber(data) {
    return request({
        url: '/wx/registrationPay/unLockNumber',
        method: 'post',
        data
    })
}

//获取可挂号科室列表
export function getAppointmentDeptList(data) {
    return request({
        url: '/internet_api/register_queue/dept/list',
        method: 'post',
        data
    })
}

//获取处方列表（扫码使用）
export function getPrescriptionList(data) {
    return request({
        url: '/internet_api/expense_mz/scanCode/wait',
        method: 'post',
        data
    })
}

/**
 * 获取系统日期
 * @param params
 * @returns {*}
 */
export function getSystemDate(params) {
    return request({
        url: '/internet_api/register_queue/getRegisterQueueTime',
        method: 'get',
        params
    })
}






// WEBPACK FOOTER //
// ./src/api/ZlInterface.js